interface StoryProgressBarProps {
    currentStep: number;
    totalSteps: number;
    status: string;
    showLabel?: boolean;
    className?: string;
}

export function StoryProgressBar({
    currentStep,
    totalSteps,
    status,
    showLabel = true,
    className = "w-20",
}: StoryProgressBarProps) {
    return (
        <div className="flex items-center gap-2">
            <div className={`${className} bg-muted rounded-full h-2`}>
                <div
                    className={`h-2 rounded-full transition-all ${
                        status === "finalized" ? "bg-progress-complete" : "bg-progress"
                    }`}
                    style={{
                        width: `${(currentStep / totalSteps) * 100}%`,
                    }}
                />
            </div>
            {showLabel && (
                <span className="text-sm text-muted-foreground">
                    {currentStep}/{totalSteps}
                </span>
            )}
        </div>
    );
}
